import type { PropsWithChildren, ReactElement } from 'react'
import { headerTitle } from './Header.css'

export const HeaderTitle = ({ children }: PropsWithChildren): ReactElement => (
  <h1 className={headerTitle}>{children}</h1>
)
